import { axios } from '@/utils/request'

const api = { 
	getPage:'/domain/getPage',
	getDomainInfo:'/domain/getDomainInfo',
	operDomainInfo:'/domain/operDataEdit',
	updateSate:'/domain/operDataState',
	loadDomainRole:'/role/searchDomainRole',
	updateDomainRole:'/role/grantDomainRole'
	
}

export default api

export function getPage (parameter) {
  return axios({
    url: api.getPage,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}
export function getDomainInfo (parameter) {
  return axios({
    url: api.getDomainInfo,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}
export function operDomainInfo (parameter) {
  return axios({
    url: api.operDomainInfo,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}
export function updateSate (parameter) {
  return axios({
    url: api.updateSate,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}
export function loadDomainRole (parameter) {
  return axios({
    url: api.loadDomainRole,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}
export function updateDomainRole (parameter) {
  return axios({
    url: api.updateDomainRole,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify({data:parameter})
  })
}



